// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-routine-dialog-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.add-to-routine-tabs {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.action-card {
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--color-white);
}

.action-card:hover {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-sm);
}

.action-card.selected {
  border-color: var(--color-primary-green);
  background-color: var(--color-light-green);
  box-shadow: 0 2px 8px var(--accent-ring);
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .add-to-routine-dialog-content {
    padding: 0px;
  }
  
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
  }
  
  .dialog-description {
    margin-bottom: 16px;
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dialogs/AddToRoutineDialog.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;AACF","sourcesContent":[".add-to-routine-dialog-content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.add-to-routine-tabs {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.action-card {\n  border: 1px solid var(--color-gray);\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: var(--color-white);\n}\n\n.action-card:hover {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-sm);\n}\n\n.action-card.selected {\n  border-color: var(--color-primary-green);\n  background-color: var(--color-light-green);\n  box-shadow: 0 2px 8px var(--accent-ring);\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .add-to-routine-dialog-content {\n    padding: 0px;\n  }\n  \n  .products-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 12px;\n  }\n  \n  .dialog-description {\n    margin-bottom: 16px;\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
